import { Box, Typography, useMediaQuery, useTheme } from "@mui/material";
import React, { useState, useEffect } from "react";
import MarkdownRenderer from "../MarkdownRenderer";
import { stripFrontMatter } from "../../utils/markdownHelpers";

// A product's "Build with LLM" page: a prompt for an AI coding assistant, in a
// single code block so the copy button copies all of it. Only the front matter
// is removed; convertMdxToMd is not used because it strips `{...}` (e.g.
// `{verificationId}`) outside code blocks.
const BuildWithLlm = ({ file, product }) => {
  const [content, setContent] = useState("");
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));

  useEffect(() => {
    if (typeof file === "string" && file.startsWith("/static")) {
      fetch(file)
        .then((res) => res.text())
        .then((raw) => setContent(stripFrontMatter(raw)));
    } else {
      setContent(stripFrontMatter(file));
    }
  }, [file]);

  return (
    <Box sx={{ padding: "0" }}>
      <Typography
        sx={{
          color: "#e54f9c",
          fontWeight: "900",
          fontSize: "0.8rem",
          marginBottom: "0.35rem",
          marginLeft: isDesktop ? "0" : "5%",
        }}
      >
        {product}
      </Typography>
      {content ? (
        <MarkdownRenderer content={content} />
      ) : (
        <p>Loading...</p>
      )}
    </Box>
  );
};

export default BuildWithLlm;
